const documentValue = (value) => {
  if (value === 'true') {
    return 'Com documento'
  }
  return 'Sem documento'
}

export default documentValue
